module.exports = __webpack_public_path__ + "static/img/Valentine-Holmes.5571ff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Valentine-Holmes.jpg
// module id = WChz
// module chunks = 0